import React from "react";
const TestimonialSection = () => {
  return (

    <section id="testimonials" className="testimonials">
    <div className="container" data-aos="fade-up">
      <div className="section-title">
        <h2>Testimonials</h2>
      </div>

      <div className="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="100">
        <div className="swiper-wrapper">

          <div className="swiper-slide">
            <div className="testimonial-wrap">
              <div className="testimonial-item">
                <h3>Akshay Lohar</h3>
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  Amazing place to solve your tech related problems. And to buy new computer laptops and lots more stuff. Worth a visit.
                  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
              </div>
            </div>
          </div>

          <div className="swiper-slide">
            <div className="testimonial-wrap">
              <div className="testimonial-item">
                <h3>Sameer Patel</h3>
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  Amazing place to solve any type of technical problem in bardoli..☺️☺️☺️👍👍👍👍
                  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
              </div>
            </div>
          </div>

          <div className="swiper-slide">
            <div className="testimonial-wrap">
              <div className="testimonial-item">
                <h3>Vivek Patel</h3>
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  I had a very good experience at progress solution. My laptop is perfectly fit and fine now to work. Thank you and keep up your service.  <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
              </div>
            </div>
          </div>

          {/* <div className="swiper-slide">
            <div className="testimonial-wrap">
              <div className="testimonial-item">
                <h3>Nirav Gupta</h3>
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  Thank you for helping in such a short notice Progress solution...I had to admit after trying many places for tech related issues, satisfactory results i got from here....honest and kind nature, always ready to help...have a good eye tech gadgets... overall great place for any tech gadgets issues...Thank you Again Progress solution<i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
              </div>
            </div>
          </div> */}

          <div className="swiper-slide">
            <div className="testimonial-wrap">
              <div className="testimonial-item">
                <h3>Aditya Anand</h3>
                <p>
                  <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                  You can find better and genuine repair and maintenance of your laptop,desktop and IT related products here at reasonable rates.
                <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                </p>
              </div>
            </div>
          </div>

        </div>
        <div className="swiper-pagination"></div>
      </div>

    </div>
  </section>
  );
};

export default TestimonialSection;
